(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/init.js');
'use strict';

const PlayerRouter = svs.app.ReactRouter.PlayerRouter;
const baseUrl = svs.core.data.baseUrl;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const Routes = svs.playerLoginReact.Routes;
const MainPage = svs.playerLoginReact.sharedComponents.MainPage;
const PlayerLoginReactReduxProvider = svs.playerLoginReact.store.PlayerLoginReactReduxProvider;
svs.playerLoginReact.init = () => {
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(PlayerLoginReactReduxProvider, null, React.createElement(ErrorBoundary, null, React.createElement(MainPage, null, React.createElement(Routes, null)))));
  ReactDOM.render(router, document.getElementsByClassName('js-react-container')[0]);
};
svs.playerLoginReact.init();

 })(window);